import { render, staticRenderFns } from "./ServiceOrder.vue?vue&type=template&id=88459ac4"
import script from "./ServiceOrder.vue?vue&type=script&lang=js"
export * from "./ServiceOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports